import { z } from "zod";
import { GameSpecsContractSchema } from "./GameSpecs";
import { EmailSubscribeContractSchema } from "./EmailSubscribe";
import { ArticleCardGridContractSchema, ArticleCardCarouselContractSchema, FeaturedNewsCarouselContractSchema, ImageCarouselContractSchema, } from "./ContentList";
import { ArticleMastheadContractSchema } from "./ArticleMasthead";
import { ArticleMediaCarouselContractSchema, ChooseFighterContractSchema, LandingMediaCarouselContractSchema, IconTabContractSchema, } from "./GroupedMediaPromo";
import { ArticleMediaEmbedContractSchema, AssetHighlightContractSchema, LandingMediaEmbedContractSchema, } from "./ContentItem";
import { ArticleMediaGalleryContractSchema, ArticlePromoCardGridContractSchema, LandingPromoCardCarouselContractSchema, } from "./MediaPromosList";
import { ArticleRichTextAccordionContractSchema, LandingRichTextAccordionContractSchema, } from "./GroupedRichText";
import { ArticleRichTextBladeContractSchema, LandingRichTextBladeContractSchema, PatchNotesRichTextBladeContractSchema, } from "./RichText";
import { AudioPlayerContractSchema } from "./AudioItem";
import { FullWidthImageContractSchema } from "./BasicBlade";
import { GameDetailMastheadContractSchema, GameSimpleMastheadContractSchema, PlatformSelectionMastheadBladeContractSchema, } from "./ProductMasthead";
import { MediaPromoBladeContractSchema, CenteredPromotionContractSchema, BetaInviteMediaPromoContractSchema, } from "./MediaPromo";
import { SeparatorContractSchema } from "./Separator";
import { TickerBannerContractSchema } from "./TickerBanner";
import { RiotBarContractSchema } from "./RiotBar";
import { CenterPromoMastheadContractSchema, MediaMastheadContractSchema, TextMastheadContractSchema, } from "./Masthead";
import { GameBetaMastheadContractSchema, BetaRegistrationMastheadContractSchema, BetaCenteredMastheadContractSchema, BetaSuccessMastheadContractSchema, BetaConnectConsoleMastheadContractSchema, BetaKeyDisplayMastheadContractSchema, BetaSurveyMastheadContractSchema, } from "./BetaRegistrationMasthead";
import { CharacterCardGridContractSchema, CharacterCardGridMiniContractSchema, } from "./CharacterList";
import { CharacterChangesBladeContractSchema, StructuredPatchNotesBladeContractSchema, } from "./StructuredPatchNotes";
import { CharacterMastheadBladeContractSchema } from "./CharacterMasthead";
import { CharacterMovesListContractSchema } from "./CharacterMovesList";
import { SimpleGameCardGridContractSchema } from "./GameCardList";
import { RiftboundCardGalleryContractSchema } from "./RiftboundCardGallery";
export const AllBladeContractsSchema = z.discriminatedUnion("type", [
    ArticleCardCarouselContractSchema,
    ArticleCardGridContractSchema,
    ArticleMastheadContractSchema,
    ArticleMediaCarouselContractSchema,
    ArticleMediaGalleryContractSchema,
    ArticleMediaEmbedContractSchema,
    ArticlePromoCardGridContractSchema,
    ArticleRichTextAccordionContractSchema,
    ArticleRichTextBladeContractSchema,
    AssetHighlightContractSchema,
    AudioPlayerContractSchema,
    BetaCenteredMastheadContractSchema,
    BetaConnectConsoleMastheadContractSchema,
    BetaInviteMediaPromoContractSchema,
    BetaKeyDisplayMastheadContractSchema,
    BetaRegistrationMastheadContractSchema,
    BetaSuccessMastheadContractSchema,
    BetaSurveyMastheadContractSchema,
    CenteredPromotionContractSchema,
    CenterPromoMastheadContractSchema,
    CharacterCardGridContractSchema,
    CharacterCardGridMiniContractSchema,
    CharacterChangesBladeContractSchema,
    CharacterMastheadBladeContractSchema,
    CharacterMovesListContractSchema,
    ChooseFighterContractSchema,
    EmailSubscribeContractSchema,
    FeaturedNewsCarouselContractSchema,
    FullWidthImageContractSchema,
    GameBetaMastheadContractSchema,
    GameDetailMastheadContractSchema,
    GameSimpleMastheadContractSchema,
    GameSpecsContractSchema,
    IconTabContractSchema,
    ImageCarouselContractSchema,
    LandingMediaCarouselContractSchema,
    LandingMediaEmbedContractSchema,
    LandingRichTextAccordionContractSchema,
    LandingRichTextBladeContractSchema,
    LandingPromoCardCarouselContractSchema,
    MediaMastheadContractSchema,
    MediaPromoBladeContractSchema,
    PatchNotesRichTextBladeContractSchema,
    PlatformSelectionMastheadBladeContractSchema,
    RiotBarContractSchema,
    SeparatorContractSchema,
    SimpleGameCardGridContractSchema,
    RiftboundCardGalleryContractSchema,
    StructuredPatchNotesBladeContractSchema,
    TickerBannerContractSchema,
    TextMastheadContractSchema,
]);
//# sourceMappingURL=all-individual-blade-contracts.js.map